// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Confirm_confirm__33hqX","heading":"Confirm_heading__1S9HG","bookbtn":"Confirm_bookbtn__2cyGb","spacing":"Confirm_spacing__1vOPE"};